export default {
  state: {
    doesShowDrawer: false,
    doesShowExpand: false,
    doesShowPropertySelect: false,
    doesShowCog: false,
    activePath: '',
    recaptchaResponse: '',
  },
  mutations: {
    openSideBar: (state: any, err: any) => {
      state.doesShowDrawer = true;
      state.doesShowExpand = true;
      state.doesShowPropertySelect = true;
      state.doesShowCog = true;
    },
    closeSideBar: (state: any, err: any) => {
      state.doesShowDrawer = true;
      state.doesShowExpand = false;
      state.doesShowPropertySelect = false;
      state.doesShowCog = true;
    },
    closeOnlySideBar: (state: any, err: any) => {
      state.doesShowDrawer = true;
      state.doesShowExpand = false;
      state.doesShowPropertySelect = true;
      state.doesShowCog = true;
    },
    switchExpand: (state: any) => {
      state.doesShowExpand = !state.doesShowExpand;
    },
    clear: (state: any, err: any) => {
      state.doesShowDrawer = false;
      state.doesShowExpand = false;
      state.doesShowPropertySelect = false;
      state.doesShowCog = false;
      state.doesShowExpand = false;
    },
    updateActivePath: (state: any, index: any) => {
      state.activePath = index;
    },
    updateRecaptchaResponse: (state: any, res: any) => {
      state.recaptchaResponse = res || '';
    },
  },
};
